import { Col, Row, Table } from 'antd';
import React, { Component } from 'react';

import ButtonMaterial from '../../../../materials/ButtonMaterial';
import CardMaterial from '../../../../materials/CardMaterial';
import DetailAdminBranchContainer from '../../../../containers/Content/ManageAccount/AdminBranch/DetailAdminBranchContainer';
import EditAdminBranchContainer from '../../../../containers/Content/ManageAccount/AdminBranch/EditAdminBranchContainer';
import ResetPasswordContainer from '../../../../containers/Content/ResetPassword/ResetPasswordContainer';
import SearchMaterial from '../../../../materials/SearchMatrial';
import SpinMaterial from '../../../../materials/SpinMaterial';
import icToggleOff from '../../../../image/ic-togge-off.svg'
import icToggleOn from '../../../../image/ic-toggle-on.svg'
import AddVersionMobileContainer from 'containers/Content/ManageAccount/VersionMobile/AddVersionMobileContainer';
import { convertToWIB } from 'lib/util'

interface IProps {
  data: any;
  PagePagination: any;
  TotalPagePagination: any;
  handlePage: any;
  handleSearchName: any;
  handleModal: any;
  searchGroup: any;
  isLoading: any;
  handleSearchGroup: any;
  refetch: any;
  handleUpdate: any
}

export default class TableVersionMobileComponent extends Component<IProps> {
  render() {
    const columns = [
      {
        title: <b>No</b>,
        width: 50,
        render: (text: any, record: any, index: any) => (
          <span>{(this.props.PagePagination - 1) * 3 + (index + 1)}</span>
        ),
      },
      {
        title: <b>Tanggal</b>,
        dataIndex: 'timestamp',
        key: 'timestamp',
        render: (time: any) => <span>{convertToWIB(time)}</span>,
        width: 120,
      },
      {
        title: <b>PIC</b>,
        dataIndex: 'actor',
        render: (actor: any) => <span className={'lightBlueColor'}>{actor}</span>,
        key: 'actor',
        width: 120,
      },
      {
        title: <b>Versi</b>,
        dataIndex: 'version',
        key: 'version',
        width: 120,
      },
      {
        title: <b>Catatan</b>,
        dataIndex: 'catatan',
        render: (catatan: any) => <span >{catatan}</span>,
        key: 'catatan',
        width: 200,
      },
      {
        title: <b>Aksi</b>,
        dataIndex: 'status',
        key: 'status',
        width: 130,
        render: (status: any, data: any) => (
          <div>
            <button name='updateVersion' style={{
              background: 'none',
              border: 'none',
              padding: 0,
              margin: 0,
              cursor: 'pointer',
              outline: 'none'
            }}
              onClick={() => this.props.handleUpdate({ version: data.version, status: !data.status })}
            >
              {
                status ? (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={icToggleOn} alt='#' style={{ width: 40, height: 40, marginRight: 4 }} />
                    <span className='lightBlueColor' style={{ width: 50, textAlign: 'left' }}>Aktif</span>
                  </div>
                )
                  : (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img src={icToggleOff} alt='#' style={{ width: 40, height: 40, marginRight: 4 }} />
                      <span className='titleModalNotifFailed' >nonaktif</span>
                    </div>
                  )
              }
            </button>
          </div>
        ),
      },
    ];
    return (
      <div>
        <AddVersionMobileContainer refetch={this.props.refetch} />
        <CardMaterial
          title={''}
          extra={''}
          style={{}}
          content={
            <div>
              <Row>
                <Col span={12}>
                  <div>
                    <span className={'titleSearchCard'}>UPDATE VERSI</span>
                    <SearchMaterial
                      value={this.props.searchGroup}
                      style={{ width: '70%' }}
                      placeholder={'Cari berdasarkan tanggal, PIC, atau versi'}
                      onChange={e =>
                        this.props.handleSearchGroup(
                          e.target.value.replace(/^\s/, '')
                        )
                      }
                    // onPressEnter={() =>
                    //   this.props.handleSearchName(this.props.searchGroup)
                    // }
                    />
                  </div>
                </Col>
                <Col span={12}>
                  <div className={'floatRight'}>
                    <ButtonMaterial
                      disabled={''}
                      handleSubmit={this.props.handleModal}
                      teksButton={<b>TAMBAH VERSI</b>}
                      size={''}
                      shape={''}
                      className={'btnLink'}
                      type={'link'}
                      icon={''}
                      style={{}}
                    />
                    <ButtonMaterial
                      disabled={''}
                      handleSubmit={this.props.handleModal}
                      teksButton={''}
                      size={''}
                      shape={'circle'}
                      className={'btnAdd'}
                      type={''}
                      icon={'plus'}
                      style={{}}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          }
        />
        <SpinMaterial
          spinning={this.props.isLoading}
          style={{}}
          size={'large'}
          content={
            <Table
              rowKey={record => record.id}
              pagination={{
                onChange: page => {
                  this.props.handlePage(page);
                },
                pageSize: 10,
                total: this.props.TotalPagePagination,
                current:
                  this.props.PagePagination === 0
                    ? 1
                    : this.props.PagePagination,
              }}
              bordered={false}
              dataSource={this.props.data}
              columns={columns}
            />
          }
        />
        <DetailAdminBranchContainer />
        <EditAdminBranchContainer refetch={this.props.refetch} />
        <ResetPasswordContainer />
      </div>
    );
  }
}
